function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 14 14"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M11 7.25v2.5q0 .93-.66 1.59T8.75 12h-6.5q-.93 0-1.59-.66T0 9.75v-6.5q0-.93.66-1.59T2.25 1h5.5q.109 0 .18.07t.07.18v.5q0 .109-.07.18T7.75 2h-5.5q-.516 0-.883.367T1 3.25v6.5q0 .516.367.883T2.25 11h6.5q.516 0 .883-.367T10 9.75v-2.5q0-.109.07-.18t.18-.07h.5q.109 0 .18.07t.07.18zM14 .5v4q0 .203-.148.352T13.5 5t-.352-.148l-1.375-1.375-5.094 5.094q-.078.078-.18.078t-.18-.078l-.891-.891q-.078-.078-.078-.18t.078-.18l5.094-5.094L9.147.851Q8.999.703 8.999.499t.148-.352.352-.148h4q.203 0 .352.148t.148.352z"
})));